<template id="landingTmpl" >
	<v-app id="vappLogin">

		<v-main>
			{{ /* v-container fluid */ }}
			<v-container>

			<ct-loading></ct-loading>
			<ct-dialog></ct-dialog>

			<slot></slot>

			</v-container>
		</v-main>
		<ct-footer></ct-footer>
	</v-app>
</template>
<script>
export default {

}
</script>